import React, {useRef, useState} from "react"
import * as Yup from "yup"
import {useSelector} from "react-redux"
import {useForm} from "react-hook-form"
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from "reactstrap"
import Switch from "react-bootstrap-switch";

// components
import Separator from "../../../components/Separator";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import {GenericButton} from "../../../components/buttons/customButtons";
import SelectGeneric from "../../../components/select/selectGeneric";

// labels
import {PH_CODE} from "../../../components/i18n/placeHolders"
import {LB_CODE, INTERNATIONAL, REQUIRED} from "../../../components/i18n/i18n"
import { FL_STATUS} from "../../../components/i18n/formLabels";
import {TT_CLOSE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";

// actions
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";

// services

// utils
import {getStateByPath} from "../../../redux/selectors";

// providers
import {aybMenuService} from "../../../jwt/_services/ayb/aybMenuService";
import {getCurrentDateForCodeField} from "../../../util/DateTools";
import AybMenuLangs from "./_langs";
import {placeProvider} from "../../../providers/placeProvider";
import SausersSection from "../restaurantController/SausersSection/SausersSection";

const AybMenuForm = props => {
    const path = props?.path ;
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { app, udn, category, editMode, domainObject} = componentState?.data;

    const fbDataBase = {id: app?.fbDataBase?.id}

    const [status, setStatus] = useState(domainObject?.status || true);
    const [langs, setlangs] = useState(domainObject?.langs || []);
    const translatableLangs = domainObject?.translatedLangs || []

    const [placeId, setPlaceId] = useState(editMode ? domainObject?.place?.id : null);
    const [isForWine, setIsForWine] = useState(domainObject?.isForWine || false)

    const [showModal, setShowModal] = useState(false)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required( REQUIRED ),
    });


    const { register, handleSubmit, reset, errors } = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id:  domainObject?.id ,
            uid:  domainObject?.uid ,
            code: (domainObject?.code || `menu_` + getCurrentDateForCodeField()).toUpperCase(), // AUTOCODE
            image:  domainObject?.image ,
            showOrder:  domainObject?.showOrder
        }
    });


    const onSubmit = (data, _) => {
        const dataRequest = {
            fbDataBase:  fbDataBase,
            item: {
                ...data,
                status: status,
                isForWine: isForWine,
                category : category,
                udn : { id: udn.id },
                langs: langs
            }
        }

        if (placeId !== undefined && placeId !== null)
            dataRequest.item.place = { id : placeId }
         else
            dataRequest.item.place = null

        if (!editMode)
            genericIndexedActions.save(path, aybMenuService, dataRequest)
        else {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, aybMenuService, id, dataRequest)
        }

        closeForm()
    };

    const onUpdateMenuCategories = (id, dataRequest) => {
        genericIndexedActions.update(path, aybMenuService, id, dataRequest)
    }

    const closeForm = () => {
        reset();
        props.onClose()
    }


    return  <>
        <Card className={'card-big-modal'}>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <>
                        <h2 className={'card-modal-title'} > { (udn?.value || '') + ' / ' + (domainObject?.title || domainObject?.name || '') }</h2>
                        <br />
                        <h5 className={'card-modal-uid'} > { '     uid: ' + (domainObject?.uid || '') }</h5>
                    </>
                    <div className={'top-right'}>
                        <GenericButton
                            style={'table'}
                            icon={'fa-save'}
                            toolTip={TT_SAVE}
                            permission={'add'}
                            onClick={handleSubmit(onSubmit)}
                        />
                        {
                            editMode && <>
                                <GenericButton
                                    style={'table'}
                                    toolTip={TT_HISTORY}
                                    icon={'fa-clock'}
                                    permission={'search'}
                                    onClick={showHistory}
                                />
                            </>
                        }
                        <Separator/>
                        <GenericButton
                            style={'danger-secondary'}
                            toolTip={TT_CLOSE}
                            icon={'fa-times'}
                            permission={'search'}
                            onClick={closeForm}
                        />
                    </div>
                </CardTitle>
                <CardBody className={'card-body-modal'}>
                    <Row>
                        <Col>
                            <Form onSubmit={ handleSubmit(onSubmit) }>
                                <Row>
                                    <Col md="8">
                                        <FormGroup>
                                            <Label>{LB_CODE}</Label>
                                            <Input
                                                type="text"
                                                name="code"
                                                placeholder={PH_CODE}
                                                innerRef={register}
                                                className={(errors.code ? ' is-invalid' : '')}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col  md="4">
                                        <FormGroup>
                                            <Label>{FL_STATUS}</Label>
                                            <br/>
                                            <Switch
                                                animate={true}
                                                offText={"No"}
                                                onText={"Si"}
                                                value={status}
                                                onChange={() => setStatus(!status)}
                                            />
                                        </FormGroup>
                                    </Col>
                                {/*<Col md="3">*/}
                                {/*    <FormGroup>*/}
                                {/*        <Label>{FL_IMAGE}</Label>*/}
                                {/*        <Input*/}
                                {/*            type="text"*/}
                                {/*            name="image"*/}
                                {/*            placeholder={PH_IMAGE}*/}
                                {/*            innerRef={register}*/}
                                {/*        />*/}
                                {/*    </FormGroup>*/}
                                {/*</Col>*/}
                                </Row>
                                <Row>
                                    <Col md="4">
                                        <FormGroup>
                                            <Label>{'Orden'}</Label>
                                            <Input
                                                type="number"
                                                name="showOrder"
                                                min="0"
                                                innerRef={register}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="4">
                                    </Col>
                                    {
                                        (category === 'REST' || category === 'HCDP_CUISINE;HCDP_BAR;HCDP_INSIDE_HOUSE') ?
                                            <Col md="4">
                                                <FormGroup>
                                                    <Label>Es menu de vinos?</Label>
                                                    <br/>
                                                    <Switch
                                                        animate={true}
                                                        offText={"No"}
                                                        onText={"Si"}
                                                        value={isForWine}
                                                        onChange={() => setIsForWine(!isForWine)}
                                                    />
                                                </FormGroup>
                                            </Col> : null
                                    }
                                    <Col md="12">
                                        <FormGroup>
                                            <Label>{'Lugar'}</Label>
                                            <SelectGeneric
                                                initialValue = { placeId }
                                                setExternalValue = { value => setPlaceId( value ) }
                                                provider = { placeProvider }
                                                customFilter={{ item : {udn: {id: udn.id}, categoryCodes : category}} }
                                            />
                                        </FormGroup>
                                    </Col>
                            </Row>
                            </Form>

                            <div className={'form-container'}>
                                <div className={''}>
                                    <h2>{ INTERNATIONAL }</h2>
                                </div>
                                <div className={''}>
                                    <Row>
                                        <AybMenuLangs
                                            langs={langs}
                                            setLangs={setlangs}
                                            translatableLangs={translatableLangs}
                                        />
                                    </Row>
                                </div>
                            </div>
                        </Col>
                        {
                            editMode && <Col>
                                <SausersSection path={path} showHeader={true} onUpdateMenuCategories={onUpdateMenuCategories}/>
                            </Col>
                        }
                    </Row>
                </CardBody>
            </Card>
        {
            showModal && <LogHistoryModal
                ref={ modalRef }
                item={ domainObject }
            />
        }
    </>
}
export default AybMenuForm